<style scoped>
  .pricingParams .ivu-form-item{ margin-bottom: 5px }
  .spaceBetween {justify-content: space-between}
</style>
<template>
  <div>
    <Form ref="pricingParams" :model="pricingParams" :label-width="80" label-position="left" class="pricingParams">
      <FormItem :label="$t('common.priceType') + '：'" prop="priceType">
        <RadioGroup v-model="pricingParams.priceType">
          <Radio :label="1">{{ $t('common.priceType0') }}</Radio>
          <Radio :label="2">{{ $t('common.priceType1') }}</Radio>
          <Radio :label="3">{{ $t('common.priceType2') }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="$t('common.weightType') + '：'" prop="weightType">
        <RadioGroup v-model="pricingParams.weightType">
          <Radio :label="1">{{ $t('common.weightType0') }}</Radio>
          <Radio :label="2">{{ $t('common.weightType1') }}</Radio>
          <Radio :label="3">{{ $t('common.weightType2') }}</Radio>
        </RadioGroup>
        <div style="display: inline-block;" v-if="pricingParams.weightType === 2 || pricingParams.weightType === 3">
          ( {{ $t('common.volumeWeight') + ':' }} <InputNumber :min="0" style="width: 100px;" v-model="pricingParams.volumeWeight"></InputNumber> )
        </div>
      </FormItem>
      <hr v-if="pricingParams.priceType === 3">
      <Form-item v-if="pricingParams.priceType === 3" :label="$t('common.priceType') + '：'" prop="subCostWay">
        <RadioGroup v-model="pricingParams.subCostWay">
          <Radio :label="1">{{ $t('common.subCostWay0') }}</Radio>
          <Radio :label="2">{{ $t('common.subCostWay1') }}</Radio>
          <Radio :label="3">{{ $t('common.subCostWay2') }}</Radio>
        </RadioGroup>
      </Form-item>
    </Form>
    <div class="normalTop flexBox spaceBetween">
      <div class="pricingFormula">
        <span>
          {{
            pricingParams.priceType === 1
              ? $t('common.tableDes0') :
                pricingParams.priceType === 2
              ? $t('common.tableDes1') :
                pricingParams.priceType === 3 && pricingParams.subCostWay === 1
              ? $t('common.tableDes0') :
                pricingParams.priceType === 3 && pricingParams.subCostWay === 2
              ? $t('common.tableDes2') :
                pricingParams.priceType === 3 && pricingParams.subCostWay === 3
              ? $t('common.tableDes1') : ''
          }}
        </span>
      </div>
      <div class="pricingButtons">
        <Button @click="showImportExcelModal" style="margin-right:10px" type="primary" size="small">{{$t('logisticsProvider.shipImport')}}</Button>
        <Button @click="addSubArea" style="margin-right:10px" type="primary" size="small">{{$t('logisticsProvider.addZone')}}</Button>
        <Button @click="editStatus = !editStatus" style="margin-right:10px" type="primary" size="small">{{!editStatus ? $t('common.edit') : $t('common.cancelEdit')}}</Button>
        <Button @click="savePricingData" type="primary" size="small" :loading="saveLoading">{{$t('common.save')}}</Button>
      </div>
    </div>
    <div class="normalTop">
      <dTable highlight-row disabled-hover border stripe :columns="pricingModelColumns" :data="cachePricingData" size="small"></dTable>
    </div>
    <!-- 国家设置弹出层 -->
    <Modal
      v-if="setStateModalStatus"
      v-model="setStateModal"
      :mask-closable="false"
      :loading="setStateModalLoading"
      @on-ok="setStateConfirm"
      transfer
      :title="$t('common.selectCountry')"
      :width = '400'
    >
      <Form ref="stateParams" :model="stateParams" label-position="left" class="pricingParams">
        <FormItem :label="$t('logisticsProvider.country') + '：'" prop="selectStateArr" :label-width="60">
          <Select v-model="stateParams.selectStateArr" multiple filterable>
            <Option v-for="(item, index) in formValidate.country" :key="index" :value="item.countryId">{{item.cnName}}</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="normalTop">
        {{$t('logisticsProvider.hasCountry')}}：{{getStateName(stateParams.selectStateArr)}}
      </div>
    </Modal>
    <!-- 模板下载 :loading="excelLoading"-->
    <Modal v-if="excelModalStatus" v-model="excelModal" transfer :mask-closable="false">
      <p slot="header">
        <span>{{$t('logisticsProvider.loadExcelTitle')}}</span>
      </p>
      <Form ref="modelParams" :model="modelParams" label-position="left">
        <FormItem :label="$t('logisticsProvider.downloadExcel') + '：'" :label-width="80">
          <a @click="downLoadExcelFiles" class="blurColor">{{$t('logisticsProvider.downloadExcel')}}</a>
        </FormItem>
        <FormItem :label="$t('logisticsProvider.selectExcel') + '：'">
          <Upload
            v-if="uploadPath && uploadHeader.hasOwnProperty('Authorization')"
            :action="uploadPath"
            :show-upload-list="false"
            :data="modelParams"
            ref="uploadFiles"
            name="file"
            :format="['xlsx', 'xls']"
            :before-upload="handleBeforeUpload"
            :headers="uploadHeader"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-format-error="handleFormatError"
            >
            <Button type="primary" class="normalRMargin">{{$t('common.selectFile')}}</Button>
          </Upload>
          <div v-if="file !== null" class="blurColor">{{file.name}}</div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="resetLoadExcel">{{$t('common.cancel')}}</Button>
        <Button type="primary" :loading="uploadLoading" @click="loadExcelModal">{{$t('common.startUpload')}}</Button>
      </div>
    </Modal>
    <!-- 删除确认框 -->
    <Modal
        v-if="delStatus"
        v-model="delModal"
        transfer
        @on-ok="delOk"
        @on-cancel="delCancel">
        <h3 style="margin:40px 40%">{{$t('common.deleteConfirm')}}</h3>
    </Modal>
    <!-- 部分国家没在系统错误提示 -->
    <Modal v-model="errModalShow" :transfer='transfer'>
      <p slot="header">
        <span>{{$t('logisticsProvider.importCountryNoFind')}}</span>
      </p>
      <div>
        <p>{{noFindCountry}}</p>
      </div>
      <div slot="footer">
        <Button @click="closeErrModal">{{$t('common.close')}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
export default {
  mixins: [ Mixin ],
  props: {
    editFlag: Boolean,
    timestamp: Number,
    shippingMethodId: [Number, String],
    shipId: {
      default: null // 渠道ID
    },
    canalFlag: {
      default: null // 渠道管理计费模型标识
    },
    isAddOrEdit: {
      default: null
    }
  },
  watch: {
    timestamp: {
      handler (n, o) {
        if (n !== o) {
          let v = this;
          if (v.canalFlag === '0') {
            if (v.shipId !== null) {
              v.getPrcingModelList();
            } else {
              v.setTableColumns(v.pricingParams.priceType);
            }
          } else {
            v.getPrcingModelList();
          }
        }
      },
      immediate: true
    },
    'pricingParams.priceType': {
      handler (n, o) {
        let v = this;
        if (n !== o) {
          v.setTableColumns(n);
          v.editStatus = false;
          if (n !== v.priceTypeStatus) { // 切换其他模板，清空数据
            v.cachePricingData = [];
          } else {
            v.getPrcingModelList();
          }
        }
      }
    },
    'pricingParams.subCostWay': {
      handler (n, o) {
        let v = this;
        if (n !== o) {
          v.editStatus = false;
          if (n !== this.subCostWayStatus) { // 切换到无数据模板时调用，重置表格数据
            v.cachePricingData = [];
            v.cachePriceModelColumns = [];
            v.setTableColumns(3);
          } else {
          //  if (v.priceTypeStatus === 3) {
          //    v.getPrcingModelList();
          //  }
          }
        }
      }
    },
    editStatus (n, o) {
      if (!n && this.shipId !== null) {
        this.getPrcingModelList();
      }
    },
    editFlag (n, o) { // 模态框关闭时，重置编辑状态
      if (n) {
        this.editStatus = false;
      }
    },
    tabDataStatus (n, o) { // 监听刷新表格数据
      if (n !== o) {
        this.getPrcingModelList();
      }
    },
    excelModalStatus (n) {
      if (n === true) {
        this.file = null;
      }
    }
  },
  data () {
    var self = this;
    return {
      uploadLoading: false, // 开始上传加载
      saveLoading: false,
      transfer: false,
      errModalShow: false,
      noFindCountry: '', // 系统没有找到相关国家
      // import excel
      excelModalStatus: false,
      excelModal: false,
      uploadPath: api.upload_excel,
      // excelLoading: true,
      modelParams: {
        priceType: 1,
        flag: 1
      },
      file: null,
      uploadHeader: {
        'Authorization': sessionStorage.getItem('token')
      },
      setStateModalStatus: false,
      setStateModal: false,
      setStateModalLoading: false,
      stateParams: {
        selectStateArr: [],
        selectIndex: null,
        selectCountryArr: []
      },
      pricingParams: {
        priceType: 1,
        weightType: 1,
        subCostWay: 1,
        volumeWeight: 0,
        shippingMethodId: null
      },
      pricingData: [],
      cachePricingData: [], // 缓存数据操作
      editStatus: false,
      pricingModelColumns: [],
      pricingModelCommonColumns: [
        {
          title: self.t('common.subArea'),
          key: 'index',
          minWidth: 70,
          align: 'center',
          render: (h, params) => {
            // return params.index + 1;
            return h('span', params.index + 1 + self.t('logisticsProvider.area'));
          }
        },
        {
          title: self.t('common.reachState'),
          key: 'reachState',
          minWidth: 150,
          maxWidth: 240,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '2px'
                  }
                }, '*'),
                h('a', {
                  style: {
                    padding: '6px 0',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      if (self.editStatus) {
                        self.showStateModal(params.index, 'ids'); // 打开国家选择
                      }
                    }
                  }
                }, self.setStateData(params.index, 'text'))
              ]);
            } else {
              return h('div', self.setStateData(params.index, 'text'));
            }
          }
        },
        {
          title: self.t('common.costPrice'),
          key: 'costPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '5px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: params.row.price ? params.row.price : null,
                    min: 0
                  },
                  style: {
                    width: '90%'
                  },
                  on: {
                    'input': (val) => {
                      self.cachePricingData[params.index].price = val;
                    }
                  }
                })
              ]);
            } else {
              return h('span', params.row.price);
            }
          }
        },
        {
          title: self.t('common.registrationFee'),
          key: 'registrationFee',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('InputNumber',
                {
                  props: {
                    value: params.row.registrationFee ? params.row.registrationFee : params.row.registrationFee === 0 ? 0 : null,
                    min: 0
                  },
                  style: {
                    width: '90%'
                  },
                  on: {
                    'input': (val) => {
                      self.cachePricingData[params.index].registrationFee = val;
                    }
                  }
                }
              );
            } else {
              return h('span', params.row.registrationFee);
            }
          }
        },
        {
          title: self.t('common.operatingCost'),
          key: 'operatingCost',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('InputNumber',
                {
                  props: {
                    value: params.row.operatingCost ? params.row.operatingCost : params.row.operatingCost === 0 ? 0 : null,
                    min: 0
                  },
                  style: {
                    width: '90%'
                  },
                  on: {
                    'input': (val) => {
                      self.cachePricingData[params.index].operatingCost = val;
                    }
                  }
                }
              );
            } else {
              return h('span', params.row.operatingCost);
            }
          }
        },
        {
          title: self.t('common.additionalFeeRate'),
          key: 'additionalFeeRate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('InputNumber',
                {
                  props: {
                    value: params.row.additionalFeeRate ? params.row.additionalFeeRate : params.row.additionalFeeRate === 0 ? 0 : null,
                    min: 0
                  },
                  style: {
                    width: '90%'
                  },
                  on: {
                    'input': (val) => {
                      self.cachePricingData[params.index].additionalFeeRate = val;
                    }
                  }
                }
              );
            } else {
              return h('span', params.row.additionalFeeRate);
            }
          }
        },
        {
          title: self.t('common.operation'),
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('Button', {
              props: {
                size: 'small'
              },
              on: {
                click: () => {
                  self.delStatus = true;
                  self.$nextTick(function () {
                    self.delModal = true;
                    self.priceModelId = params.row.priceModelId;
                    self.priceModelZoneId = params.row.priceModelZoneId;
                    self.delIndex = params.index;
                  });
                }
              }
            }, self.t('common.del'));
          }
        }
      ],
      pricingModelContinuedHeavyColumns: [
        {
          title: self.t('common.firstWeight'),
          key: 'firstWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '5px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: params.row.firstWeight ? params.row.firstWeight : null,
                    min: 0
                  },
                  style: {
                    width: '90%'
                  },
                  on: {
                    'input': (val) => {
                      self.cachePricingData[params.index].firstWeight = val;
                    }
                  }
                })
              ]);
            } else {
              return h('span', params.row.firstWeight);
            }
          }
        },
        {
          title: self.t('common.firstWeightPrice'),
          key: 'firstWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '5px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: params.row.firstWeightPrice ? params.row.firstWeightPrice : null,
                    min: 0
                  },
                  style: {
                    width: '90%'
                  },
                  on: {
                    'input': (val) => {
                      self.cachePricingData[params.index].firstWeightPrice = val;
                    }
                  }
                })
              ]);
            } else {
              return h('span', params.row.firstWeightPrice);
            }
          }
        },
        {
          title: self.t('common.unitWeight'),
          key: 'unitWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '5px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: params.row.unitWeight ? params.row.unitWeight : null,
                    min: 0
                  },
                  style: {
                    width: '90%'
                  },
                  on: {
                    'input': (val) => {
                      self.cachePricingData[params.index].unitWeight = val;
                    }
                  }
                })
              ]);
            } else {
              return h('span', params.row.unitWeight);
            }
          }
        },
        {
          title: self.t('common.unitWeightPrice'),
          key: 'unitWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.editStatus) {
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '5px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: params.row.unitWeightPrice ? params.row.unitWeightPrice : null,
                    min: 0
                  },
                  style: {
                    width: '90%'
                  },
                  on: {
                    'input': (val) => {
                      self.cachePricingData[params.index].unitWeightPrice = val;
                    }
                  }
                })
              ]);
            } else {
              return h('span', params.row.unitWeightPrice);
            }
          }
        }
      ],
      cachePriceModelColumns: [],
      priceTypeStatus: null, // 存储表格数据的计费方式
      subCostWayStatus: null, // 存储表格数据分段下的计费方式
      delModal: false, // 删除确认模态框
      delStatus: false,
      priceModelId: '', // 删除分区
      priceModelZoneId: '',
      delIndex: null,
      tabDataStatus: false // 是否刷新表格数据
    };
  },
  methods: {
    resetForm () {
      let v = this;
      v.cachePriceModelColumns = [];
      v.cachePricingData = [];
      v.pricingData = [];
      v.tabDataStatus = false;
    },
    // 获取计费模型表格数据
    getPrcingModelList () {
      let v = this;
      v.resetForm();
      if (v.canalFlag === '0') {
        v.axios.post(api.get_shippingInfo + '?shippingMethodId=' + v.shipId)
          .then(res => {
            if (res.data.code === 0) {
              let newData = res.data.datas;
              if (v.isAddOrEdit === 'add') {
                if (newData !== null) {
                  let resData = newData.priceModel;
                  let data = resData.priceModelZoneList;
                  v.setTableColumns(resData.priceType);
                  v.priceTypeStatus = resData.priceType;
                  v.pricingParams.priceType = resData.priceType;
                  v.pricingParams.weightType = resData.weightType;
                  v.pricingParams.shippingMethodId = resData.shippingMethodId;
                  v.pricingParams.volumeWeight = resData.volumeWeight;
                  v.pricingData = data;
                  v.cachePricingData = data;
                  v.setCachePriceModelColumns();
                  if (data.length > 0 && data[0].priceModelExtendList.length > 0) { // 获取分段下的计费方式
                    v.pricingParams.subCostWay = data[0].priceModelExtendList[0].priceType;
                    v.subCostWayStatus = data[0].priceModelExtendList[0].priceType;
                  }
                } else {
                  v.setTableColumns(v.pricingParams.priceType);
                }
              } else if (v.isAddOrEdit === 'edit') {
                if (newData.priceModel !== null) {
                  let resData = newData.priceModel;
                  let data = resData.priceModelZoneList;
                  v.setTableColumns(resData.priceType);
                  v.priceTypeStatus = resData.priceType;
                  v.pricingParams.priceType = resData.priceType;
                  v.pricingParams.weightType = resData.weightType;
                  v.pricingParams.shippingMethodId = resData.shippingMethodId;
                  v.pricingParams.volumeWeight = resData.volumeWeight;
                  v.pricingData = data;
                  v.cachePricingData = data;
                  v.setCachePriceModelColumns();
                  if (data.length > 0 && data[0].priceModelExtendList.length > 0) { // 获取分段下的计费方式
                    v.pricingParams.subCostWay = data[0].priceModelExtendList[0].priceType;
                    v.subCostWayStatus = data[0].priceModelExtendList[0].priceType;
                  }
                } else {
                  v.setTableColumns(v.pricingParams.priceType);
                }
              }
            } else {
              v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
            }
          });
      } else {
        v.axios.post(api.get_shipInfo + '?shippingMethodId=' + v.shippingMethodId)
          .then(response => {
            if (response.data.code === 0) {
              let resData = response.data.datas;
              if (resData !== null) {
                let data = resData.priceModelZoneList;
                v.setTableColumns(resData.priceType);
                v.priceTypeStatus = resData.priceType;
                v.pricingParams.priceType = resData.priceType;
                v.pricingParams.weightType = resData.weightType;
                v.pricingParams.shippingMethodId = resData.shippingMethodId;
                v.pricingParams.volumeWeight = resData.volumeWeight;
                v.pricingData = data;
                v.cachePricingData = data;
                v.setCachePriceModelColumns();
                if (data.length > 0 && data[0].priceModelExtendList.length > 0) { // 获取分段下的计费方式
                  v.pricingParams.subCostWay = data[0].priceModelExtendList[0].priceType;
                  v.subCostWayStatus = data[0].priceModelExtendList[0].priceType;
                }
              } else {
                v.setTableColumns(1);
              }
            } else {
              v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
            }
          });
      }
      console.log(this.shipId);
      console.log(this.canalFlag);
      // console.log(v.isAddOrEdit);
    },
    setCachePriceModelColumns () {
      let v = this;
      v.cachePriceModelColumns = [];
      if (v.cachePricingData.length > 0 && v.cachePricingData[0].priceModelExtendList !== null) {
        if (v.cachePricingData.length > 0 && v.cachePricingData[0].priceModelExtendList.length > 0 && v.pricingParams.priceType === 3) { // 判断已有ExtendList数量，插入缓存区域
          for (let i = 0; i < v.cachePricingData[0].priceModelExtendList.length; i++) {
            let item = v.deepCopy(v.cachePricingData[0].priceModelExtendList[i]);
            let culumnItem = {
              align: 'center',
              minWidth: 230,
              renderHeader: (h, col) => {
                if (v.editStatus) {
                  return h('div', [
                    h('span', {
                      style: {
                        color: 'red',
                        marginRight: '5px',
                        position: 'relative',
                        top: '4px'
                      }
                    }, '*'),
                    h('Input', {
                      props: {
                        value: item.startWeight,
                        number: true,
                        size: 'small'
                      },
                      style: {
                        width: '60px'
                      },
                      on: {
                        'input': (val) => {
                          for (let t = 0; t < v.cachePricingData.length; t++) {
                            v.cachePricingData[t].priceModelExtendList[i].startWeight = val;
                          }
                        }
                      }
                    }),
                    h('span', {
                      style: {
                        margin: '0 3px'
                      }
                    }, '-'),
                    h('Input', {
                      props: {
                        value: item.endWeight ? item.endWeight : null,
                        number: true,
                        size: 'small'
                      },
                      style: {
                        width: '60px'
                      },
                      on: {
                        'input': (val) => {
                          for (let t = 0; t < v.cachePricingData.length; t++) {
                            v.cachePricingData[t].priceModelExtendList[i].endWeight = val;
                          }
                        }
                      }
                    }),
                    h('span', {
                      style: {
                        margin: '0 3px'
                      }
                    }, 'g'),
                    h('Icon', {
                      props: {
                        type: 'android-add-circle',
                        size: 16,
                        color: '#3cb034'
                      },
                      style: {
                        position: 'relative',
                        top: '3px',
                        cursor: 'pointer'
                      },
                      on: {
                        click: () => {
                          v.inserNewColumn(col.index, item);
                        }
                      }
                    }),
                    h('Icon', {
                      props: {
                        type: 'android-cancel',
                        size: 16,
                        color: '#f00'
                      },
                      style: {
                        position: 'relative',
                        top: '3px',
                        cursor: 'pointer',
                        margin: '0 3px'
                      },
                      on: {
                        click: () => {
                          v.delColumns(col.index);
                        }
                      }
                    })
                  ]);
                } else {
                  return h('div',
                    [
                      h('span', item.startWeight),
                      h('span', {
                        style: {
                          margin: '0 3px'
                        }
                      }, '-'),
                      h('span', item.endWeight),
                      h('span', {
                        style: {
                          margin: '0 3px'
                        }
                      }, 'g')
                    ]
                  );
                }
              },
              render: (h, params) => {
                if (v.editStatus && v.pricingParams.subCostWay === 3) { // 编辑状态下，priceType等于3时返回结果
                  return h('div',
                    {
                      style: {
                        padding: '8px 0'
                      }
                    },
                    [
                      h('div',
                        {
                          class: 'flexBox'
                        },
                        [
                          h('span', {
                            style: {
                              color: 'red',
                              marginRight: '5px',
                              position: 'relative',
                              top: '8px'
                            }
                          }, '*'),
                          h('span', {
                            style: {
                              position: 'relative',
                              top: '6px',
                              'margin-right': '5px'
                            }
                          }, v.t('common.firstWeightTwo')),
                          h('InputNumber',
                            {
                              props: {
                                value: v.cachePricingData[params.index].priceModelExtendList[i].firstWeight ? v.cachePricingData[params.index].priceModelExtendList[i].firstWeight : null,
                                min: 0,
                                size: 'small'
                              },
                              style: {
                                width: '60px',
                                marginTop: '3px'
                              },
                              on: {
                                'input': (val) => {
                                  v.cachePricingData[params.index].priceModelExtendList[i].firstWeight = val;
                                }
                              }
                            }
                          ),
                          h('span', {
                            style: {
                              position: 'relative',
                              top: '6px',
                              'margin': '0 5px'
                            }
                          }, 'g'),
                          h('InputNumber',
                            {
                              props: {
                                value: v.cachePricingData[params.index].priceModelExtendList[i].firstWeightPrice ? v.cachePricingData[params.index].priceModelExtendList[i].firstWeightPrice : null,
                                min: 0,
                                size: 'small'
                              },
                              style: {
                                width: '60px',
                                marginTop: '3px'
                              },
                              on: {
                                'input': (val) => {
                                  v.cachePricingData[params.index].priceModelExtendList[i].firstWeightPrice = val;
                                }
                              }
                            }
                          ),
                          h('span', {
                            style: {
                              position: 'relative',
                              top: '6px',
                              'margin-left': '5px'
                            }
                          }, v.t('common.monetaryUnit'))
                        ]
                      ),
                      h('div',
                        {
                          class: 'flexBox normalTop'
                        },
                        [
                          h('span', {
                            style: {
                              color: 'red',
                              marginRight: '5px',
                              position: 'relative',
                              top: '8px'
                            }
                          }, '*'),
                          h('span', {
                            style: {
                              position: 'relative',
                              top: '6px',
                              'margin-right': '5px'
                            }
                          }, v.t('common.unitWeightTwo')),
                          h('InputNumber',
                            {
                              props: {
                                value: v.cachePricingData[params.index].priceModelExtendList[i].unitWeight ? v.cachePricingData[params.index].priceModelExtendList[i].unitWeight : null,
                                min: 0,
                                size: 'small'
                              },
                              style: {
                                width: '60px',
                                marginTop: '3px'
                              },
                              on: {
                                'input': (val) => {
                                  v.cachePricingData[params.index].priceModelExtendList[i].unitWeight = val;
                                }
                              }
                            }
                          ),
                          h('span', {
                            style: {
                              position: 'relative',
                              top: '6px',
                              'margin': '0 5px'
                            }
                          }, 'g'),
                          h('InputNumber',
                            {
                              props: {
                                value: v.cachePricingData[params.index].priceModelExtendList[i].unitWeightPrice ? v.cachePricingData[params.index].priceModelExtendList[i].unitWeightPrice : null,
                                min: 0,
                                size: 'small'
                              },
                              style: {
                                width: '60px',
                                marginTop: '3px'
                              },
                              on: {
                                'input': (val) => {
                                  v.cachePricingData[params.index].priceModelExtendList[i].unitWeightPrice = val;
                                }
                              }
                            }
                          ),
                          h('span', {
                            style: {
                              position: 'relative',
                              top: '6px',
                              'margin-left': '5px'
                            }
                          }, v.t('common.monetaryUnit'))
                        ]
                      )
                    ]);
                } else if (v.editStatus && v.pricingParams.subCostWay === 2) { // 编辑状态下，priceType等于2时返回结果
                  return h('div', [
                    h('span', {
                      style: {
                        color: 'red',
                        marginRight: '5px',
                        position: 'relative',
                        top: '5px'
                      }
                    }, '*'),
                    h('InputNumber', {
                      props: {
                        value: v.cachePricingData[params.index].priceModelExtendList[i].price ? v.cachePricingData[params.index].priceModelExtendList[i].price : null,
                        min: 0
                      },
                      style: {
                        width: '80%'
                      },
                      on: {
                        'input': (val) => {
                          v.cachePricingData[params.index].priceModelExtendList[i].price = val;
                        }
                      }
                    })
                  ]);
                } else if (v.editStatus && v.pricingParams.subCostWay === 1) { // 编辑状态下，priceType等于1时返回结果
                  return h('div',
                    {
                      class: 'flexBox'
                    },
                    [
                      h('span', {
                        style: {
                          color: 'red',
                          marginRight: '5px',
                          position: 'relative',
                          top: '10px'
                        }
                      }, '*'),
                      h('InputNumber',
                        {
                          props: {
                            value: v.cachePricingData[params.index].priceModelExtendList[i].price ? v.cachePricingData[params.index].priceModelExtendList[i].price : null,
                            min: 0
                          },
                          style: {
                            width: '75%'
                          },
                          on: {
                            'input': (val) => {
                              v.cachePricingData[params.index].priceModelExtendList[i].price = val;
                            }
                          }
                        }
                      ),
                      h('span', {
                        style: {
                          position: 'relative',
                          top: '6px',
                          'margin-left': '5px'
                        }
                      }, '元/g')
                    ]
                  );
                } else if (!v.editStatus && v.pricingParams.subCostWay === 3) { // 非编辑状态下返回，priceType = 3;
                  return h('div',
                    [
                      h('div',
                        {
                          class: 'flexBox'
                        },
                        [
                          h('span', {
                            style: {
                              'margin-right': '5px'
                            }
                          }, v.t('common.firstWeightTwo')),
                          h('span', v.cachePricingData[params.index].priceModelExtendList[i].firstWeight),
                          h('span', {
                            style: {
                              'margin': '0 5px'
                            }
                          }, 'g,'),
                          h('span', v.cachePricingData[params.index].priceModelExtendList[i].firstWeightPrice),
                          h('span', {
                            style: {
                              'margin-left': '5px'
                            }
                          }, v.t('common.monetaryUnit'))
                        ]
                      ),
                      h('div',
                        {
                          class: 'flexBox'
                        },
                        [
                          h('span', {
                            style: {
                              'margin-right': '5px'
                            }
                          }, v.t('common.unitWeightTwo')),
                          h('span', v.cachePricingData[params.index].priceModelExtendList[i].unitWeight),
                          h('span', {
                            style: {
                              'margin': '0 5px'
                            }
                          }, 'g,'),
                          h('span', v.cachePricingData[params.index].priceModelExtendList[i].unitWeightPrice),
                          h('span', {
                            style: {
                              'margin-left': '5px'
                            }
                          }, v.t('common.monetaryUnit'))
                        ]
                      )
                    ]
                  );
                } else if (!v.editStatus && v.pricingParams.subCostWay === 2) { // 非编辑状态下返回，priceType = 3;
                  let price = v.cachePricingData[params.index].priceModelExtendList[i].price === null ? 0 : v.cachePricingData[params.index].priceModelExtendList[i].price;
                  return h('span', price + '元/票');
                } else {
                  let price = v.cachePricingData[params.index].priceModelExtendList[i].price === null ? 0 : v.cachePricingData[params.index].priceModelExtendList[i].price;
                  return h('span', price + '元/g');
                }
              }
            };
            v.cachePriceModelColumns.push(culumnItem);
          }
        }
      }
    },
    inserNewColumn (index, item) {
      let v = this;
      item.endWeight = 0;
      item.firstWeight = 0;
      item.firstWeightPrice = 0;
      item.price = 0;
      item.startWeight = 0;
      item.unitWeight = 0;
      item.unitWeightPrice = 0;
      for (let t = 0; t < v.cachePricingData.length; t++) {
        v.cachePricingData[t].priceModelExtendList.splice(index, 0, v.deepCopy(item));
        if (t === v.cachePricingData.length - 1) {
          v.pricingModelColumns = [];
          v.setCachePriceModelColumns();
          v.$nextTick(function () {
            v.setTableColumns(v.pricingParams.priceType);
          });
        }
      }
    },
    delColumns (index) {
      let v = this;
      let i = index - 2;
      if (v.cachePriceModelColumns.length < 2) {
        v.$Message.error(v.t('error.delPricingColumnsError'));
        return false;
      }
      for (let t = 0; t < v.cachePricingData.length; t++) {
        v.cachePricingData[t].priceModelExtendList.splice(i, 1);
        if (t === v.cachePricingData.length - 1) {
          v.pricingModelColumns = [];
          v.setCachePriceModelColumns();
          v.$nextTick(function () {
            v.setTableColumns(v.pricingParams.priceType);
          });
        }
      }
    },
    setTableColumns (type) { // 设置表格列
      let v = this;
      if (type === 1) {
        v.pricingModelColumns = v.pricingModelCommonColumns;
      } else if (type === 2) {
        v.getNewArr(v.pricingModelCommonColumns)
          .then(arr => {
            arr.splice(2, 1, ...v.pricingModelContinuedHeavyColumns);
            v.pricingModelColumns = arr;
          });
      } else {
        v.getNewArr(v.pricingModelCommonColumns)
          .then(arr => {
            arr.splice(2, 1, ...v.cachePriceModelColumns);
            v.pricingModelColumns = arr;
          });
      }
    },
    getNewArr (arr) { // 浅拷贝数组
      let newArr = [];
      return new Promise(resolve => {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          newArr.push(item);
          if (i === arr.length - 1) {
            resolve(newArr);
          }
        }
      });
    },
    setStateData (index, type) { // 整理国家数据
      let v = this;
      for (let i = 0; i < v.cachePricingData.length; i++) {
        if (i === index) {
          let stateNameArr = [];
          let stateIdArr = [];
          let item = v.cachePricingData[index].priceModelCountryList;
          if (item.length === 0) return '请选择国家';
          for (let t = 0; t < item.length; t++) {
            let subItem = item[t];
            if (subItem.cnName !== null && subItem.cnName !== '' && subItem.cnName !== undefined) {
              stateNameArr.push(subItem.cnName);
            } else {
              stateNameArr.push('请选择国家');
            }
            stateIdArr.push(subItem.countryId);
            if (t === item.length - 1 && type === 'text') {
              return stateNameArr.toString();
            } else if (t === item.length - 1 && type === 'ids') {
              return stateIdArr;
            }
          }
        }
      }
    },
    showStateModal (index) { // 打开国家设置层
      let v = this;
      let ids = v.setStateData(index, 'ids');
      v.stateParams.selectIndex = index;
      v.setStateModalStatus = true;
      v.$nextTick(function () {
        v.setStateModal = true;
        v.stateParams.selectStateArr = ids;
      });
    },
    setStateConfirm () { // 设置国家信息插入到缓存数据中
      let v = this;
      v.cachePricingData[v.stateParams.selectIndex].priceModelCountryList = v.stateParams.selectCountryArr;
    },
    getStateName (arr) { // 国家id 转 名称
      let v = this;
      if (arr.length === 0) return '';
      let arrName = [];
      let countryArr = [];
      for (let i = 0; i < v.formValidate.country.length; i++) {
        let item = v.formValidate.country[i];
        for (let t = 0; t < arr.length; t++) {
          let subItem = arr[t];
          if (subItem === item.countryId) {
            arrName.push(item.cnName);
            countryArr.push(item);
          }
          if (i === v.formValidate.country.length - 1 && t === arr.length - 1) {
            v.stateParams.selectCountryArr = countryArr;
            return arrName.toString();
          }
        }
      }
    },
    handleSubmit (arr) { // 保存数据时检测国家数据是否为空
      let status = true;
      let pos = [];
      return new Promise(resolve => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].priceModelCountryList.length === 0) {
            status = false;
          } else { // 判断是否有重复国家
            for (let t = 0; t < arr[i].priceModelCountryList.length; t++) {
              let item = arr[i].priceModelCountryList[t];
              pos.push(item.cnName);
            }
            let array = Array.from(new Set(pos));
            if (array.length !== pos.length) {
              status = false;
            }
          }
          if (i === arr.length - 1 && status) {
            resolve(true);
          } else if (i === arr.length - 1 && !status) {
            resolve(false);
          }
        }
      });
    },
    savePricingData () { // 保存数据
      let v = this;
      if (v.canalFlag === '0') {
        v.pricingParams.shippingMethodId = v.shipId; // 渠道管理渠道ID
      } else {
        v.pricingParams.shippingMethodId = v.shippingMethodId;
      }
      let obj = Object.assign({}, v.pricingParams);
      obj.priceModelZoneList = v.cachePricingData;
      // 校验小数位及非零、非空项
      let item = obj.priceModelZoneList;
      if (item.length === 0) {
        v.$Message.error(v.t('error.currentNoData'));
        return;
      }
      let reg = /^\d+(\.\d{1,5})?$/; // 只能保留五位小数
      let regTw = /^([1-9]\d*|[0]{1,1})$/; // 含0的正整数
      // && v.editStatus
      // if (item.length > 0) {
      for (let i = 0; i < item.length; i++) {
        // 校验国家
        if (item[i].priceModelCountryList === null || item[i].priceModelCountryList.length === 0) {
          v.$Message.error(v.t('error.nonCountry'));
          return false;
        }
        if (!reg.test(item[i].registrationFee)) {
          v.$Message.error(v.t('error.decimalError'));
          return false;
        } else if (!reg.test(item[i].operatingCost)) {
          v.$Message.error(v.t('error.decimalError'));
          return false;
        } else if (!reg.test(item[i].additionalFeeRate)) {
          v.$Message.error(v.t('error.decimalError'));
          return false;
        }
        if (v.pricingParams.priceType === 1) {
          if (!reg.test(item[i].price)) {
            v.$Message.error(v.t('error.decimalError'));
            return false;
          } else if (item[i].price === 0 || item[i].price === null || item[i].price === undefined) {
            v.$Message.error(v.t('error.priceError'));
            return false;
          }
        } else if (v.pricingParams.priceType === 2) {
          if (!reg.test(item[i].firstWeight)) {
            v.$Message.error(v.t('error.decimalError'));
            return false;
          } else if (!reg.test(item[i].firstWeightPrice)) {
            v.$Message.error(v.t('error.decimalError'));
            return false;
          } else if (!reg.test(item[i].unitWeight)) {
            v.$Message.error(v.t('error.decimalError'));
            return false;
          } else if (!reg.test(item[i].unitWeightPrice)) {
            v.$Message.error(v.t('error.decimalError'));
            return false;
          } else if (item[i].firstWeight === 0 || item[i].firstWeight === null || item[i].firstWeight === undefined) {
            v.$Message.error(v.t('error.firstWeightError'));
            return false;
          } else if (item[i].firstWeightPrice === 0 || item[i].firstWeightPrice === null || item[i].firstWeightPrice === undefined) {
            v.$Message.error(v.t('error.firstWeightPriceError'));
            return false;
          } else if (item[i].unitWeight === 0 || item[i].unitWeight === null || item[i].unitWeight === undefined) {
            v.$Message.error(v.t('error.unitWeightError'));
            return false;
          } else if (item[i].unitWeightPrice === 0 || item[i].unitWeightPrice === null || item[i].unitWeightPrice === undefined) {
            v.$Message.error(v.t('error.unitWeightPriceError'));
            return false;
          }
        } else if (v.pricingParams.priceType === 3 && (v.pricingParams.subCostWay === 1 || v.pricingParams.subCostWay === 2)) {
          for (let t = 0; t < item[i].priceModelExtendList.length; t++) {
            let pos = item[i].priceModelExtendList[t];
            if (!reg.test(pos.price)) {
              v.$Message.error(v.t('error.decimalError'));
              return false;
            } else if (pos.price === 0 || pos.price === null || pos.price === undefined) {
              v.$Message.error(v.t('error.priceError'));
              return false;
            } else if (pos.startWeight < 0 || pos.startWeight === null || pos.startWeight === undefined || pos.endWeight <= 0 || pos.endWeight === null || pos.endWeight === undefined || !regTw.test(pos.startWeight) || !regTw.test(pos.endWeight)) {
              v.$Message.error(v.t('error.weightRegionError'));
              return false;
            }
          }
        } else if (v.pricingParams.priceType === 3 && v.pricingParams.subCostWay === 3) {
          for (let t = 0; t < item[i].priceModelExtendList.length; t++) {
            let pos = item[i].priceModelExtendList[t];
            if (!reg.test(pos.firstWeight)) {
              v.$Message.error(v.t('error.decimalError'));
              return false;
            } else if (!reg.test(pos.firstWeightPrice)) {
              v.$Message.error(v.t('error.decimalError'));
              return false;
            } else if (!reg.test(pos.unitWeight)) {
              v.$Message.error(v.t('error.decimalError'));
              return false;
            } else if (!reg.test(pos.unitWeightPrice)) {
              v.$Message.error(v.t('error.decimalError'));
              return false;
            } else if (pos.firstWeight === 0 || pos.firstWeight === null || pos.firstWeight === undefined) {
              v.$Message.error(v.t('error.firstWeightError'));
              return false;
            } else if (pos.firstWeightPrice === 0 || pos.firstWeightPrice === null || pos.firstWeightPrice === undefined) {
              v.$Message.error(v.t('error.firstWeightPriceError'));
              return false;
            } else if (pos.unitWeight === 0 || pos.unitWeight === null || pos.unitWeight === undefined) {
              v.$Message.error(v.t('error.unitWeightError'));
              return false;
            } else if (pos.unitWeightPrice === 0 || pos.unitWeightPrice === null || pos.unitWeightPrice === undefined) {
              v.$Message.error(v.t('error.unitWeightPriceError'));
              return false;
            } else if (pos.startWeight < 0 || pos.startWeight === null || pos.startWeight === undefined || pos.endWeight <= 0 || pos.endWeight === null || pos.endWeight === undefined || !regTw.test(pos.startWeight) || !regTw.test(pos.endWeight)) {
              v.$Message.error(v.t('error.weightRegionError'));
              return false;
            }
          }
        }
      }
      if (v.canalFlag === '0' && v.shipId !== null) {
        v.saveLoading = false;
        v.$nextTick(function () {
          v.saveLoading = true;
        });
      } else if (v.canalFlag !== '0') {
        v.saveLoading = false;
        v.$nextTick(function () {
          v.saveLoading = true;
        });
      }
      // }
      v.handleSubmit(obj.priceModelZoneList)
        .then(result => {
          if (result) {
            if (v.canalFlag === '0') {
              if (this.shipId === null) {
                // v.editStatus = false;
                v.$Message.success(v.t('common.saveSuccess'));
                v.$emit('sendData', obj); // 新增的计费模型数据
              } else {
                v.axios.post(api.updatePriceModel, JSON.stringify(obj))
                  .then(response => {
                    if (response.data.code === 0) {
                      v.saveLoading = false; // 保存加载状态
                      v.$Message.success(v.t('common.saveSuccess'));
                      v.editStatus = false;
                      v.$emit('closeModal', obj);
                    } else {
                      v.saveLoading = false; // 保存加载状态
                      v.$Message.error(v.t('common.saveFailed'));
                      v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
                    }
                  });
              }
            } else {
              v.axios.post(api.update_priceModel, JSON.stringify(obj))
                .then(res => {
                  if (res.data.code === 0) {
                    v.saveLoading = false;
                    v.$Message.success(v.t('common.saveSuccess'));
                    v.editStatus = false;
                  } else {
                    v.$Message.error(v.t('common.saveFailed'));
                    v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
                  }
                });
            }
          } else {
            v.$Message.error(v.t('error.nonCountry'));
          }
        });
    },
    // 新增分区
    addSubArea () {
      let v = this;
      v.editStatus = true;
      if (v.cachePricingData.length === 0) {
        let obj = {
          zoneName: '1',
          price: 0,
          registrationFee: 0,
          operatingCost: 0,
          firstWeight: 0,
          firstWeightPrice: 0,
          unitWeight: 0,
          unitWeightPrice: 0,
          additionalFeeRate: 0,
          arriveCountryName: null,
          priceModelExtendList: [
            {
              startWeight: 0,
              endWeight: 0,
              price: 0,
              priceType: v.pricingParams.subCostWay,
              firstWeight: 0,
              firstWeightPrice: 0,
              unitWeight: 0,
              usedBy: 1,
              unitWeightPrice: 0
            }
          ],
          priceModelCountryList: []
        };
        v.cachePricingData.push(obj);
        if (v.pricingParams.priceType === 3) {
          v.setTableColumns(3);
        }
        v.setCachePriceModelColumns();
      } else {
        if (v.cachePricingData[0].priceModelExtendList === null || v.cachePricingData[0].priceModelExtendList.length === 0) {
          let obj = {
            zoneName: v.cachePricingData.length + 1,
            price: 0,
            registrationFee: 0,
            operatingCost: 0,
            firstWeight: 0,
            firstWeightPrice: 0,
            unitWeight: 0,
            unitWeightPrice: 0,
            additionalFeeRate: 0,
            arriveCountryName: null,
            priceModelExtendList: [],
            priceModelCountryList: []
          };
          v.cachePricingData.push(obj);
        } else {
          v.getNewPriceModelExtendList(v.cachePricingData[0].priceModelExtendList)
            .then(arr => {
              let obj = {
                zoneName: v.cachePricingData.length + 1,
                price: 0,
                registrationFee: 0,
                operatingCost: 0,
                firstWeight: 0,
                firstWeightPrice: 0,
                unitWeight: 0,
                unitWeightPrice: 0,
                additionalFeeRate: 0,
                arriveCountryName: null,
                priceModelExtendList: arr,
                priceModelCountryList: []
              };
              v.cachePricingData.push(obj);
            });
        }
      }
    },
    // 深拷贝一次priceModelExtendList,并重置部分值
    getNewPriceModelExtendList (arr) {
      let v = this;
      let newArr = [];
      return new Promise(resolve => {
        for (let i = 0; i < arr.length; i++) {
          let item = v.deepCopy(arr[i]);
          item.price = 0;
          item.firstWeight = 0;
          item.firstWeightPrice = 0;
          item.unitWeight = 0;
          item.unitWeightPrice = 0;
          newArr.push(item);
          if (i === arr.length - 1) {
            resolve(newArr);
          }
        }
      });
    },
    // 下载模板
    downLoadExcelFiles () {
      let v = this;
      const relativePath = window.location.host + '/static/files/';
      let fileName;
      if (v.pricingParams.priceType === 3) {
        if (v.pricingParams.subCostWay === 1) {
          fileName = '分段计费-单位重量.xlsx';
        } else if (v.pricingParams.subCostWay === 2) {
          fileName = '分段计费-固定收费.xlsx';
        } else {
          fileName = '分段计费-首续重.xlsx';
        }
      } else if (v.pricingParams.priceType === 2) {
        fileName = '计费模型导入模板-首续重计费.xlsx';
      } else {
        fileName = '计费模型导入模板-普通计费.xlsx';
      }
      window.location.href = '//' + relativePath + fileName;
    },
    // 关闭没有相关国家错误信息
    closeErrModal () {
      this.errModalShow = false;
    },
    // 导入成功
    uploadSuccess (response, file, fileList) {
      let v = this;
      // v.excelLoading = false;
      // v.$nextTick(function () {
      //   v.excelLoading = true;
      // });
      if (response.code === 0) {
        let msg = response.message; // 获取错误信息
        if (msg.indexOf('Accessible countries are not found in the system') === -1) {
          // v.excelLoading = false;
          v.uploadLoading = false; // 开始上传加载中
          v.excelModal = false;
          v.editStatus = true;
          v.file = null;
          v.cachePricingData = [];
          v.pricingModelColumns = [];
          let data = response.datas;
          let total = v.cachePricingData.length;
          if (data !== null && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              item.zoneName = total + i + 1;
              item.priceType = v.pricingParams.priceType;
              v.cachePricingData.push(item);
            }
          }
          v.setTableColumns(v.pricingParams.priceType);
          v.setCachePriceModelColumns();
          v.$Message.success({
            content: v.t('logisticsProvider.importSuccess'),
            duration: 3
          });
        } else {
          v.errModalShow = true;
          v.noFindCountry = response.message.replace('通达国家没在系统找到/Accessible countries are not found in the system', '');
          // v.excelLoading = false;
          v.uploadLoading = false; // 开始上传加载中
          v.excelModal = false;
          v.editStatus = true;
          v.file = null;
          v.cachePricingData = [];
          v.pricingModelColumns = [];
          let data = response.datas;
          let total = v.cachePricingData.length;
          if (data !== null && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              item.zoneName = total + i + 1;
              item.priceType = v.pricingParams.priceType;
              v.cachePricingData.push(item);
            }
          }
          v.setTableColumns(v.pricingParams.priceType);
          v.setCachePriceModelColumns();
        }
      } else {
        v.uploadLoading = false; // 开始上传加载中
        v.showErrorInfoFn(response.code, response.data.message); // 错误提示方法
        v.excelModal = true;
      }
    },
    uploadError (res, file, fileList) {
      let v = this;
      v.$Message.error(v.t('common.operateFailMes'));
    },
    // 上传文件格式校验
    handleFormatError (file) {
      let v = this;
      v.$Notice.warning({
        title: v.t('validValue.fileError'),
        desc: file.name + v.t('validValue.fileError') + ',' + v.t('common.pleaseSelect') + 'xlsx or xls'
      });
      // v.excelLoading = false;
      // v.$nextTick(function () {
      //   v.excelLoading = true;
      // });
    },
    handleBeforeUpload (file) {
      let v = this;
      v.file = file;
      return false;
    },
    // 确认上传
    loadExcelModal () {
      let v = this;
      if (v.file === null) {
        v.$Message.error(v.t('error.selectModalFile'));
        // v.excelLoading = false;
        // v.$nextTick(function () {
        //   v.excelLoading = true;
        // });
        v.excelModal = true;
        return;
      } else {
        if (v.errModalShow === true) {
          v.errModalShow = true;
        }
      }
      v.uploadLoading = true; // 开始上传加载中
      this.$refs['uploadFiles'].post(v.file);
    },
    // 导入模态框取消
    resetLoadExcel () {
      this.file = null;
      this.excelModal = false;
    },
    showImportExcelModal () { // 导入
      let v = this;
      v.modelParams.priceType = v.pricingParams.priceType;
      if (v.pricingParams.priceType !== 3) {
        delete v.modelParams.flag;
      } else {
        v.modelParams.flag = v.pricingParams.subCostWay;
      }
      v.excelModalStatus = true;
      v.$nextTick(function () {
        v.excelModal = true;
      });
    },
    // 确认删除
    delOk () {
      let v = this;
      if (v.priceModelId !== '' && v.priceModelId !== null && v.priceModelId !== undefined && v.priceModelZoneId !== '' && v.priceModelZoneId !== null && v.priceModelZoneId !== undefined) {
        v.axios.post(api.del_zone + '?priceModelId=' + v.priceModelId + '&priceModelZoneId=' + v.priceModelZoneId)
          .then(res => {
            if (res.data.code === 0) {
              v.tabDataStatus = true;
            } else {
              v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
            }
          });
      }
      v.cachePricingData.splice(v.delIndex, 1);
    },
    delCancel () { // 取消删除
      let v = this;
      v.delModal = false;
    }
  },
  mounted () {
    let v = this;
    setTimeout(v.getCountrys(), 2000);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/pricingModel_old.vue